import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=a7508e4c&"
import script from "./Disclosure.vue?vue&type=script&lang=js&"
export * from "./Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports